module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/javascript-572dc3f7f267bd032f7f1498705bc9b6.svg";